type Listener = () => void;

let pointerDragging = false;
let wheelActive = false;
let cameraMoving = false;
let settleTimer: ReturnType<typeof setTimeout> | null = null;
let wheelTimer: ReturnType<typeof setTimeout> | null = null;
let motionTimer: ReturnType<typeof setTimeout> | null = null;

const listeners = new Set<Listener>();

function notify() {
  for (const listener of listeners) listener();
}

function isCurrentlyActive(): boolean {
  return pointerDragging || wheelActive || cameraMoving || settleTimer !== null;
}

/**
 * True while the 3D orbit/pan pointer is down, wheel zooming, or camera is in motion/settling.
 * Hot paths and LOD promotion poll this to avoid swapping or mounting objects during movement.
 */
export const cameraDragStore = {
  isDragging: () => isCurrentlyActive(),

  setDragging(next: boolean) {
    if (next) {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
      if (!pointerDragging) {
        pointerDragging = true;
        notify();
      }
    } else {
      pointerDragging = false;
      // Keep active for a brief settling grace period (400ms)
      // so rapid successive pan/orbit gestures or damping glide don't thrash object loading
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        settleTimer = null;
        notify();
      }, 400);
    }
  },

  notifyWheel() {
    if (!wheelActive) {
      wheelActive = true;
      notify();
    }
    if (wheelTimer) clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => {
      wheelActive = false;
      wheelTimer = null;
      notify();
    }, 400);
  },

  notifyCameraMotion() {
    if (!cameraMoving) {
      cameraMoving = true;
      notify();
    }
    if (motionTimer) clearTimeout(motionTimer);
    motionTimer = setTimeout(() => {
      cameraMoving = false;
      motionTimer = null;
      notify();
    }, 350);
  },

  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
